/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Loading_CalendarsInputs */

const en_settings_loading_calendars = /** @type {(inputs: Settings_Loading_CalendarsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading calendars…`)
};

const he_settings_loading_calendars = /** @type {(inputs: Settings_Loading_CalendarsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`טוען יומנים…`)
};

/**
* | output |
* | --- |
* | "Loading calendars…" |
*
* @param {Settings_Loading_CalendarsInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const settings_loading_calendars = /** @type {((inputs?: Settings_Loading_CalendarsInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Loading_CalendarsInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_loading_calendars(inputs)
	return he_settings_loading_calendars(inputs)
});